import * as LessonsV3 from '../../model/v3/lessons';

export class LessonProgressUtilsV3 {
  public static readonly READING_RECOMMENDATION = 22;
  public static readonly REVISION_RECOMMENDATION = 6;

  public static proposedRevisionPage(nwp: number | null): number {
    return Math.max((nwp ?? 0) - LessonProgressUtilsV3.REVISION_RECOMMENDATION, 1);
  }

  public static proposedReadingPage(nwp: number | null): number {
    return Math.max((nwp ?? 0) - LessonProgressUtilsV3.READING_RECOMMENDATION, 1);
  }

  /** Proposed progress for the upcoming lesson, derived from the last committed one. */
  public static buildProposedProgress(
    lastProgress: LessonsV3.CallanProgressDetails | null
  ): LessonsV3.CallanProgressDetails {
    const nwp = lastProgress?.nwp ?? 0;
    return {
      start: LessonProgressUtilsV3.proposedRevisionPage(nwp),
      nwp,
      reading: lastProgress?.reading
        ? LessonProgressUtilsV3.proposedReadingPage(nwp)
        : null,
      headwords: lastProgress?.headwords ?? '',
      productVersion: null,
    };
  }
}
